<template>
    <div class="multiple-view-container">
        <button type="button" class="files-button" @click.prevent="showFiles = !showFiles">
            <span class="material-symbols-outlined">folder_copy</span>
            Dosyalar
        </button>
        <Transition name="fade">
            <div v-show="showFiles" class="files-container">
                <div v-for="file in files" :key="file.Id" class="files">
                    <FileDownloadLink ref="fileDownloadLink" @cannotPreview="showPreviewOptions"
                        :isPreviewing="file.IsPreviewing" :custom-style="true" :show-dropdown="false" :document="file"
                        @preview="showFilePreview"></FileDownloadLink>
                </div>
            </div>
        </Transition>
        <FilePreview v-if="currentViewingFile" :key="currentViewingFile.Id" :file="currentViewingFile"
            :viewer="viewer || viewerType" :customHeight="true" :multiple-view-enabled="true" @changeShowFiles="showFiles = !showFiles" @close="$emit('closeMultipleFilePreview')">
        </FilePreview>
        <div v-else-if="previewOptionsVisible" class="previewOptionsContainer">
            <button type="button" class="unavaliableFileCloseButton" aria-label="Kapat" @click="$emit('closeMultipleFilePreview')">
                <span class="material-symbols-outlined">close</span>
            </button>
            <p class="mv-name" v-if="currentlyUnavailableFile.UnsignedFile">{{ currentlyUnavailableFile.UnsignedFile.FileName }}</p>
            <p class="mv-name" v-else>{{ currentlyUnavailableFile.FileName }}</p>
            <p class="mv-text">Bu dosya görüntülenemiyor.</p>
            <p class="mv-text">Aşağıdaki butonu kullanarak dosyayı indirebilirsiniz.</p>
            <div class="mv-action">
                <button type="button" class="mv-download" @click="downloadUnavailableFile">İndir</button>
            </div>
        </div>
        <div v-else class="loadingContainer">
            <span class="mv-spinner"></span>
            Yükleniyor...
        </div>
    </div>
</template>

<script>
import FilePreview from './FilePreview.vue';
import FileDownloadLink from './FileDownloadLink.vue';
import axios from 'axios';
export default {
    components: {
        FilePreview,
        FileDownloadLink
    },
    props: {
        files: {
            type: Array,
            default: null
        },
        viewerType: {
            type: String,
        },
        clickedFileId: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            showFiles: false,
            file: null,
            currentViewingFile: null,
            viewer: null,
            previewOptionsVisible: false,
            currentlyUnavailableFile: null
        };
    },
    mounted() {
        setTimeout(() => {
            this.openClickedFile()
        }, 200);
    },
    methods: {
        downloadUnavailableFile() {
            console.log(this.currentlyUnavailableFile)
            if (!this.currentlyUnavailableFile.IsAttachment) {
                axios.post(`/${this.currentlyUnavailableFile.UnsignedFile ? this.currentlyUnavailableFile.UnsignedFile.EntityType : this.currentlyUnavailableFile.EntityType}/createDocumentUrl/`, {
                    EntityId: this.currentlyUnavailableFile.EntityId,
                    DocumentId: this.currentlyUnavailableFile.Id,
                })
                    .then(x => {
                        console.log("createDocumentUrl Result:", x.data);
                        window.open(x.data.Data.Url);
                    })
                    .catch(x => window.processErrorResponse(x, this));
            }else{
                axios.post(`/${this.currentlyUnavailableFile.UnsignedFile ? this.currentlyUnavailableFile.UnsignedFile.EntityType : this.currentlyUnavailableFile.EntityType}/createAttachmentUrl/`, {
                    EntityId: this.currentlyUnavailableFile.EntityId,
                    AttachmentId: this.currentlyUnavailableFile.Id,
                })
                    .then(x => {
                        console.log("createAttachmentUrl Result:", x.data);
                        window.open(x.data.Data.Url);
                    })
                    .catch(x => window.processErrorResponse(x, this));
            }
        },
        showPreviewOptions(document, type) {
            this.currentViewingFile = null;
            this.viewer = type;

            this.files.map(x => x.IsPreviewing = false)
            if (this.files[0].Document) {
                if (document.Document.DocumentId) {
                    this.files.map(x => x.IsPreviewing = document.Document.DocumentId == x.Document.DocumentId ? true : false)
                } else {
                    this.files.map(x => x.IsPreviewing = document.Document.Id == x.Document.Id ? true : false)
                }
            } else {
                this.files.map(x => x.IsPreviewing = document.Id == x.Id ? true : false)
            }
            this.previewOptionsVisible = true;
            this.showFiles = false;
            this.currentlyUnavailableFile = document
            this.currentlyUnavailableFile.EntityId = document.UnsignedFile ? document.UnsignedFile.EntityId : document.EntityId;
        },
        openClickedFile() {
            var indexFunction;
            if (this.files[0].Document) {
                indexFunction = (file) => file.Document.DocumentId ? file.Document.DocumentId : file.Document.Id == this.clickedFileId;
            } else {
                indexFunction = (file) => file.Id == this.clickedFileId;
            }
            var index = this.files.findIndex(indexFunction)
            this.$refs.fileDownloadLink[index].$refs.customClick.click()
            this.showFiles = false;
        },
        showFilePreview(document, type, isFormatted) {
            this.files.map(x => x.IsPreviewing = false)
            if (this.files[0].Document) {
                if (document.Document.DocumentId) {
                    this.files.map(x => x.IsPreviewing = document.Document.DocumentId == x.Document.DocumentId ? true : false)
                } else {
                    this.files.map(x => x.IsPreviewing = document.Document.Id == x.Document.Id ? true : false)
                }
            } else {
                this.files.map(x => x.IsPreviewing = document.Id == x.Id ? true : false)
            }

            this.currentViewingFile = document;
            this.viewer = type;
            this.currentViewingFile.EntityId = document.UnsignedFile ? document.UnsignedFile.EntityId : document.EntityId;
            if (isFormatted)
                this.currentViewingFile.IsFormatted = true;
            else
                this.currentViewingFile.IsFormatted = false;

            this.showFiles = false;
        },
    }
}
</script>

<style scoped>
/* Voya: çoklu dosya görüntüleyici */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to{
    opacity: 0;
}

.multiple-view-container {
    position: fixed;
    top: 0px;
    left: 0px;
    height: 100vh;
    width: 100vw;
    background-color: #F8F8F8;
    font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
    color: #092154;
}

.files-button {
    z-index: 1000;
    position: fixed;
    top: calc(57px + env(safe-area-inset-top, 0px) + 12px);
    left: 12px;
    height: 44px;
    padding: 0 16px 0 12px;
    border: 1px solid #EFEFEF;
    border-radius: 100px;
    background-color: #ffffff;
    box-shadow: 0 2px 12px rgba(9, 33, 84, 0.18);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: inherit;
    font-weight: 600;
    font-size: 14px;
    color: #092154;
}

.files-button .material-symbols-outlined {
    font-size: 22px;
}

.files-button:active {
    background-color: #F4F6FA;
}

.files-container {
    z-index: 1000;
    position: fixed;
    top: calc(57px + env(safe-area-inset-top, 0px) + 12px + 44px + 8px);
    left: 12px;
    right: 12px;
    max-height: 60vh;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 8px;
    border: 1px solid #EFEFEF;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 8px 32px rgba(9, 33, 84, 0.2);
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.previewOptionsContainer{
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    padding: calc(57px + env(safe-area-inset-top, 0px) + 96px) 24px 0 24px;
    text-align: center;
}

.mv-name {
    margin: 0 0 8px 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;
    color: #092154;
    word-break: break-all;
}

.mv-text {
    margin: 0;
    font-size: 14px;
    line-height: 150%;
    color: #808080;
}

.mv-action {
    width: 100%;
    max-width: 320px;
    margin-top: 16px;
}

.mv-download {
    width: 100%;
    height: 48px;
    border: none;
    border-radius: 8px;
    background-color: #092154;
    font-family: inherit;
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
}

.mv-download:active {
    background-color: #182F5E;
}

.unavaliableFileCloseButton{
    position: fixed;
    right: 12px;
    top: calc(57px + env(safe-area-inset-top, 0px) + 12px);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    padding: 0;
    border: 1px solid #EFEFEF;
    border-radius: 50%;
    background-color: #ffffff;
    box-shadow: 0 2px 12px rgba(9, 33, 84, 0.18);
    color: #092154;
    font-size: 24px;
}

.unavaliableFileCloseButton:active {
    background-color: #F4F6FA;
}

.loadingContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 200px 0 0 0;
    font-weight: 500;
    font-size: 13px;
    color: #808080;
}

.mv-spinner {
    width: 18px;
    height: 18px;
    border: 2px solid #FCE3CE;
    border-top-color: #F37615;
    border-radius: 50%;
    animation: mv-spin 0.8s linear infinite;
}

@keyframes mv-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
